import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myLeaveRoleFiltersState = atom({
  key: "myLeaveRoleFiltersState",
  default: {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
